import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';
import PersonCard from '../components/PersonCard';
import { Input } from '../components/ui/input';
import { Search, Users } from 'lucide-react';

export default function PeoplePage() {
  const [people, setPeople] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(search), 300);
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    const fetchPeople = async () => {
      setLoading(true);
      try {
        const params = debouncedSearch ? `?search=${encodeURIComponent(debouncedSearch)}` : '';
        const res = await axios.get(`${API}/people${params}`);
        setPeople(res.data);
      } catch (error) {
        console.error('Error fetching people:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchPeople();
  }, [debouncedSearch]);

  return (
    <div className="min-h-screen py-12 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-4">
            <Users className="w-8 h-8 text-cyan-400" />
            <h1 className="font-heading text-3xl md:text-5xl font-bold" data-testid="people-title">
              People & Entities
            </h1>
          </div>
          <p className="text-white/50 max-w-2xl">
            Researchers, witnesses, scientists, and key figures in the interconnected web of paranormal phenomena.
          </p>
        </div>

        {/* Search */}
        <div className="relative mb-8 max-w-md">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-white/30" />
          <Input
            type="text"
            placeholder="Search by name, role, or expertise..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="pl-10 bg-white/5 border-white/10 text-white placeholder:text-white/30"
            data-testid="people-search"
          />
        </div>

        {/* Results */}
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[...Array(9)].map((_, i) => (
              <div key={i} className="skeleton h-40 rounded-sm" />
            ))}
          </div>
        ) : people.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-white/50">No people found matching your search.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="people-grid">
            {people.map(person => (
              <PersonCard key={person.person_id} person={person} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
